import { Grid, Switch, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import fieldStyles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'; 
import globalStyles from '../../../../../assets/styles/global.module.scss';
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { emptyDelayObject, isCurrentViewVersionPublished } from '../../utilityFunctions';
import { chatbotTriggerConfigs, triggerConfigs } from '../../../../../models/flowBuilderTypes';
import { generateUUID } from '../../../../../utils/constants';
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import SmartDelayPopup from './smartDelay/smartDelayPopup';
import SmartDelayTablePopup from './smartDelay/smartDelayTablePopup';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { useSearchParams } from 'react-router-dom';
import agent from '../../../../../services/api';
import { getCurrentViewVersionsTriggers, setVersionsInTriggerConfigs } from '../../flowBuilderConstants';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';

interface SmartDelayProps {
    flagStepLevel: boolean,
    stepId?: string,
} 

const SmartDelay: React.FC<SmartDelayProps> = (props) => {
    
    const { flagStepLevel, stepId } = props;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload; 
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload 
    const { nodes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const chatbotTriggerConfigs = useFlowBuilderStore((store) => store.chatbotTriggerConfigs);
    const setChatbotTriggerConfigs = useFlowBuilderStore((store) => store.setChatbotTriggerConfigs);
    
    const [flagSmartDelayPopup, setFlagSmartDelayPopup] = useState<boolean>(false);
    const [flagSmartDelayTablePopup, setFlagSmartDelayTablePopup] = useState<boolean>(false);

    const [selectedTrigger, setSelectedTrigger] = useState<triggerConfigs | null>(null);
    
    const [searchParams] = useSearchParams();
    const workflow_id = searchParams.get('workflow_id')

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const getStepTriggers = () => {
        const triggers: chatbotTriggerConfigs | undefined =  getCurrentViewVersionsTriggers(chatbotTriggerConfigs, currentActiveStaticWorkflow);
        if(!triggers?.trigger_configs) return [];

        return triggers?.trigger_configs?.filter((config) => {
            if(flagStepLevel){
                return (config?.flag_step_level && stepId == config?.chatbot_step_id);
            }

            return !config?.flag_step_level;
        });
    }

    const getSmartDelaySwitchValue = () => {
        const step_trigger = getStepTriggers();
        if(step_trigger && step_trigger?.length > 0) return true;
        else if(selectedTrigger){
            if(flagStepLevel) {
                return selectedTrigger?.chatbot_step_id === stepId;
            }
            return true;
        }     
        else return false;
    }

    const onChangeOfSmartDelaySwitch = (value: boolean) => {
        let updatedChatbotTriggerConfigs;
        if(!chatbotTriggerConfigs){
            updatedChatbotTriggerConfigs = null;
        } else {
            updatedChatbotTriggerConfigs =  chatbotTriggerConfigs?.map((triggers: chatbotTriggerConfigs) => {
                if(triggers?.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase()){
                    return {
                        ...triggers, 
                        trigger_configs: value ? triggers.trigger_configs 
                            : 
                            triggers.trigger_configs?.filter((config) => {
                                if(flagStepLevel){
                                    return !(config?.flag_step_level && config?.chatbot_step_id == stepId);
                                } 
                                return config?.flag_step_level;
                            })
                    }
                }
                return triggers;
            })
        }
        setChatbotTriggerConfigs(updatedChatbotTriggerConfigs);
        if(value){
            setSelectedTrigger(emptyDelayObject(generateUUID(), flagStepLevel, flagStepLevel ? stepId : null));
        } else {
            setSelectedTrigger(null);
            const triggers = getStepTriggers();
            if(triggers && triggers?.length > 0){
                let draftVersionsTriggers: chatbotTriggerConfigs | undefined = getCurrentViewVersionsTriggers(chatbotTriggerConfigs, currentActiveStaticWorkflow);
                const triggers_to_remove = draftVersionsTriggers?.trigger_configs?.filter((trigger) => !triggers?.some((tri) => tri?.chatbot_timeout_trigger_config_id == trigger?.chatbot_timeout_trigger_config_id)) ?? [];
                updateChatbotTriggerConfigs(triggers_to_remove);
            }
        }
    }

    const showDelayConfigurationMessage = () => {
        if(!chatbotTriggerConfigs) return "";
        const step_trigger = getStepTriggers();
        const configureSmartDelayText = "Configure Smart Delay";

        if(step_trigger?.length == 0) return configureSmartDelayText;
        for(let i = 0; i < step_trigger?.length; ++i){
            if(!step_trigger[i]?.flag_saved_in_BE){
                return configureSmartDelayText;
            }
        }
        return "View Smart Delay";
    }

    const handleSmartDelayEditClick = () => {

        const step_trigger = getStepTriggers();

        if(step_trigger && step_trigger?.length > 0){
            setFlagSmartDelayTablePopup(true);
            setFlagSmartDelayPopup(false);
        } else {
            setFlagSmartDelayPopup(true);
            setFlagSmartDelayTablePopup(false);
            setSelectedTrigger(emptyDelayObject(generateUUID(), flagStepLevel, flagStepLevel ? stepId : null));
        }
    }

    const updateChatbotTriggerConfigs = async (trigger_configs: triggerConfigs[]) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const payload = {
            chatbot_id: workflow_id ?? "", 
            trigger_configs: trigger_configs,
        }

        const res = await agent.updateChatbotTriggerConfig.put(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            let triggers = setVersionsInTriggerConfigs(res?.data);
            triggers = triggers?.map((config: chatbotTriggerConfigs) => {
                return {
                    ...config, 
                    trigger_configs: config?.trigger_configs?.map((trigger) => {
                        return {
                            ...trigger, 
                            flag_saved_in_BE: true,
                        }
                    }) 
                }
            })
            setChatbotTriggerConfigs(triggers);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    const getStepNameByStepId = (id: string, defaultValue: string) => {
        const step = nodes?.find((node: any) => node?.id == id);
        if(step){
            return step?.chatbot_step_name;
        }
        return defaultValue;
    }

    const getSmartDelayDescription = () => {
        let description = `Handle smart delay at`; 
        if(flagStepLevel){
            return `${description} this step:`;
        } else {
            return `${description} chatbot:`;
        }
    }

    return (
        <>
            <Grid item className={globalStyles.fullwidth}>
                <Grid container direction={"column"} gap={"10px"}>
                    <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                        <Grid container justifyContent={"space-between"} alignContent={"center"}>
                            <Grid item className={`${globalStyles.displayFlex} ${styles.handleErrorTitle}`}>Smart Delay</Grid>
                            <Grid item>
                                <Switch
                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    checked={getSmartDelaySwitchValue()}
                                    onChange={(e) => onChangeOfSmartDelaySwitch(e.target.checked)}
                                />
                            </Grid>
                        </Grid>
                    </Grid> 

                    {getSmartDelaySwitchValue() && 
                        <>
                            <Grid item xs={12} className={`${textStyles.templatesContainer}`}>
                                <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                                    <Grid item className={styles.exceptionTitle}>
                                        {getSmartDelayDescription()}
                                    </Grid>
                                    <Grid item className={`${styles.contentBlockSubHeadingStyle} ${styles.intentContentBlock}`}>
                                        <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                            <Grid item className={globalStyles.wordBreakBreakWord}>
                                                {showDelayConfigurationMessage()}
                                            </Grid>
                                            <Grid item>
                                                <ModeEditIcon
                                                    className={styles.editIcon}
                                                    onClick={() => handleSmartDelayEditClick()}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    }

                </Grid>
            </Grid>

            {flagSmartDelayPopup && 
                <GlobalPopUp
                    open={flagSmartDelayPopup}
                    onClose={() => { setFlagSmartDelayPopup(false)}}
                    handleClose={() => { setFlagSmartDelayPopup(false)}}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "850px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "850px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <SmartDelayPopup
                        getStepTriggers={getStepTriggers}
                        selectedTrigger={selectedTrigger as triggerConfigs}
                        setSelectedTrigger={setSelectedTrigger as React.Dispatch<React.SetStateAction<triggerConfigs>>}
                        updateChatbotTriggerConfigs={updateChatbotTriggerConfigs}
                        getStepNameByStepId={getStepNameByStepId}
                        setFlagSmartDelayPopup={setFlagSmartDelayPopup}
                        flagStepLevel={flagStepLevel} 
                        stepId={stepId} 
                    />
                </GlobalPopUp>
            }

            {flagSmartDelayTablePopup && 
                <GlobalPopUp
                    open={flagSmartDelayTablePopup}
                    onClose={() => { setFlagSmartDelayTablePopup(false)}}
                    handleClose={() => { setFlagSmartDelayTablePopup(false)}}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "950px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "1050px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <SmartDelayTablePopup
                        getStepTriggers={getStepTriggers}
                        selectedTrigger={selectedTrigger}
                        setSelectedTrigger={setSelectedTrigger}
                        setFlagSmartDelayPopup={setFlagSmartDelayPopup}
                        updateChatbotTriggerConfigs={updateChatbotTriggerConfigs}
                        getStepNameByStepId={getStepNameByStepId}
                        flagStepLevel={flagStepLevel} 
                        stepId={stepId}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default SmartDelay
